import storeInit from "storeInit";
import {isEmpty} from "lodash";

export default function isValidationEnabled(){
  const state = storeInit.getState();
  const {collector} = state.surveyResponse;
  const url = new URL(window.location.href);

  let validationEnabled = true;

  url.searchParams.forEach((value, key) => {
    if(key === 'disableValidations' && parseInt(value) === 1){
      validationEnabled = false;
    }
  })

  if(
    (
      collector
      && collector.type === 'Test'
      && collector.enabledValidations === false
    )
  ){
    validationEnabled = false;
  }

  return validationEnabled;
}